import { removeSpaces } from "@/helpers/Text";
import {CheckboxList, CheckboxItem} from "thrive-components";

export interface ICheckboxMenu {
    infoTitle:string;
    items: CheckboxItem[];
}
  
interface IDropdownCheckboxMenuProps {
    checkboxMenus: ICheckboxMenu[]; 
}


const DropdownCheckboxMenu = ({checkboxMenus}: IDropdownCheckboxMenuProps) => {
    return (
        <div className='dropdown-menu'>
            {checkboxMenus.map((menu) => (
                menu.items.length
                    ?   <CheckboxList 
                            key={removeSpaces(`${menu.infoTitle}-react-ddm`)}
                            items={menu.items} 
                            title={menu.infoTitle} 
                            className={"dropdown-menu-style"} 
                        />
                    :   undefined
                )).filter((menu) => menu)
            }
        </div>
    );
};
export default DropdownCheckboxMenu